class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-drawer');
    this.notificationSuccess = this.notification.querySelector('.cart-drawer__success');

    this.button = document.getElementById('cart-icon-bubble');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    
    this.init(); 
  }

  init() {
    this.querySelectorAll('button[type="button"].cart-drawer__close').forEach((closeButton) =>
    closeButton.addEventListener('click', this.close.bind(this))
  );
    
    // Initialize cart note auto-save
    this.initCartNoteAutoSave();
  }

  initCartNoteAutoSave() {
    const cartNoteTextarea = document.getElementById('cart-drawer-note');
    if (cartNoteTextarea) {
      // Debounce the save function to prevent excessive API calls
      this.debouncedSaveNote = debounce((note) => {
        this.saveCartNote(note);
      }, 500);

      cartNoteTextarea.addEventListener('blur', (event) => {
        const note = event.target.value.trim();
        if (note !== this.lastSavedNote) {
          this.debouncedSaveNote(note);
        }
      });

      // Store the initial note value
      this.lastSavedNote = cartNoteTextarea.value.trim();
    }
  }

  saveCartNote(note) {
    const body = JSON.stringify({
      note: note
    });

    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! ${response.status}`);
        }
        this.lastSavedNote = note;
        console.log('Cart note saved successfully');
      })
      .catch((error) => {
        console.error('Error saving cart note:', error);
        // Optionally show user feedback for the error
        const errorElement = document.getElementById('notification-cart-errors');
        if (errorElement) {
          errorElement.textContent = 'Failed to save note. Please try again.';
          setTimeout(() => {
            errorElement.textContent = '';
          }, 3000);
        }
      });
  }


  open() {
    this.notification.classList.add('animate', 'active');
    this.classList.add('active');
    this.button.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');




    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    this.classList.remove('active');
    this.button.classList.remove('active');
    if (this.notificationSuccess) this.notificationSuccess.classList.add('hidden');




    document.body.removeEventListener('click', this.onBodyClick);
    document.body.classList.remove('overflow-hidden');

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));
      if (this.notificationSuccess) this.notificationSuccess.classList.remove('hidden');
      if (this.header) this.header.reveal();
    this.open();
    this.init();
  }


  getSectionsToRender() {
      return [
        {
          id: 'cart-notification-products'
        },
        {
          id: 'cart-notification-links'
        },
        {
          id: 'cart-notification-extra'
        },
        {
          id: 'cart-icon-bubble'
        }
      ];
    }


  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && target !== this.button  && !target.closest('cart-drawer')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);


class CartLink extends HTMLElement {
  constructor() {
    super();

    this.cartNotification = document.querySelector('cart-drawer');
    if (this.cartNotification) {
       
      this.addEventListener('click', (event) => {
        event.preventDefault();
        if (this.cartNotification.header) this.cartNotification.header.reveal();
        this.cartNotification.open();
      });
    }
  }

}

customElements.define('cart-link', CartLink);

if (!customElements.get('cart-drawer-items')) {


  class CartNotificationItems extends HTMLElement {
    constructor() {
      super();

      this.lineItemStatusElement = document.getElementById('cart-drawer-shopping-cart-line-item-status');

      this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
        .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      this.addEventListener('change', this.debouncedOnChange.bind(this));

    }

    onChange(event) {
      console.log('onChange called with:', { event });
      if (event.target.closest('gift-product')) return;
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target, event.target.dataset.id, event.target.dataset.extraKey);
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-notification-products',
          section: 'cart-notification-products',
          selector: '.shopify-section'
        },
        {
          id: 'cart-notification-links',
          section: 'cart-notification-links',
          selector: '.shopify-section'
        },
        {
          id: 'cart-notification-warning',
          section: 'cart-notification-warning',
          selector: '.shopify-section'
        },
        {
          id: 'cart-notification-extra',
          section: 'cart-notification-extra',
          selector: '.shopify-section'
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        }
      ];
    }

    addProduct(id, quantity) {
      const body = JSON.stringify({
        id,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartFooter = document.getElementById('main-cart-footer');
          const cartItems = document.getElementById('main-cart-items');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        
            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        
          }));
          cartItems.scrollIntoView();


          this.disableLoading();
        }).catch((e) => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          document.getElementById('notification-cart-errors').textContent = window.cartStrings.error;
          this.disableLoading();
        });
    }



    updateQuantity(line, quantity, name, input, id, extraKey) {
      console.log('updateQuantity called with:', { line, quantity, name, input, id, extraKey });
      
      this.max = input?.max;      
      if (this.max) {
        if (quantity > input.max) {
          document.getElementById(`Line-item-error-${line}`)
            .querySelector('.notification-cart-item__error-text')
            .innerHTML = window.cartStrings.quantityError.replace(
              '[quantity]',
              input.max
            );
          quantity = input.max;
        }
      }
      
      this.enableLoading(line);


      const updates = {
        [id]: quantity
      }
      
      if (extraKey) {
        updates[extraKey] = quantity;
      }




      const body = JSON.stringify({
        updates,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      console.log('updateQuantity request body:', body);

      return fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          console.log('updateQuantity response status:', response.status);
          if (!response.ok) {
            return response.text().then(text => {
              console.error('Error response:', text);
              throw new Error(`HTTP error! ${response.status}`);
            });
          }
          return response.text();
        })
        .then((state) => {
          console.log('updateQuantity success, parsing state');
          const parsedState = JSON.parse(state);
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }));

          this.updateLiveRegions(line, parsedState.item_count);
          const lineItem = document.getElementById(`CartItem-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`) && input) lineItem.querySelector(`[name="${name}"]`).focus();
          this.disableLoading();
          return parsedState;
        }).catch((e) => {
          console.error('Error in updateQuantity:', e);
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          document.getElementById('notification-cart-errors').textContent = window.cartStrings.error;
          this.disableLoading();
          throw e;
        });
    }

    updateLiveRegions(line, itemCount) {
      // console.log(line);
      // if (this.currentItemCount === itemCount) {
      //   document.getElementById(`Line-item-error-${line}`)
      //     .querySelector('.notification-cart-item__error-text')
      //     .innerHTML = window.cartStrings.quantityError.replace(
      //       '[quantity]',
      //       document.getElementById(`Quantity-${line}`).value
      //     );
      // }

      this.currentItemCount = itemCount;
      this.lineItemStatusElement.setAttribute('aria-hidden', true);

      const cartStatus = document.getElementById('cart-drawer-cart-live-region-text');
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
      line = line + 1;
      document.getElementById('cart-drawer').classList.add('cart__items--disabled');
      this.querySelectorAll(`#cart-drawer-product-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
      document.activeElement.blur();
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }

    disableLoading() {
      document.getElementById('cart-drawer').classList.remove('cart__items--disabled');
    }
  }

  customElements.define('cart-drawer-items', CartNotificationItems);
  
}

class NotificationCartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      console.log('Removing item with index:', this.dataset.index);
      console.log('extraKey:', this.dataset.extraKey);
      this.closest('cart-drawer-items').updateQuantity(this.dataset.index, 0, document.activeElement.getAttribute('name'), event.target, this.dataset.id, this.dataset.extraKey);
    });
  }
}

customElements.define('notification-cart-remove-button', NotificationCartRemoveButton);

class ProductGift extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector('.gift-product__checkbox');
    this.productId = this.dataset.product;
    this.cartItems = document.querySelector('cart-drawer-items');
    this.mainProductTitle = this.closest('.cart-notification-product')?.querySelector('.cart-notification-product__name')?.textContent || '';
    this.mainProductId = this.dataset.productId;
    this.lineItemKey = this.dataset.lineItemKey;
    this.lineItemId = this.dataset.lineItemId;
    
    if (this.checkbox) {
      this.checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
    }
  }

  async handleCheckboxChange(event) {
    // Prevent the default behavior to avoid triggering other event handlers
    event.preventDefault();
    event.stopPropagation();
    
    if (!this.cartItems) return;

    if (this.checkbox) this.checkbox.disabled = true;
    const cartDrawer = document.getElementById('cart-drawer');
    if (cartDrawer) cartDrawer.classList.add('cart__items--disabled');

    try {
      if (event.target.checked) {
        const variantIdToAdd = this.dataset.product;
        if (variantIdToAdd) {
           console.log('Checkbox checked, adding product with ID:', variantIdToAdd);
          await this.addProductWithProperties(variantIdToAdd, 1);
        } else {
          console.warn('Checkbox checked, but no valid product ID to add (data-product is missing/invalid).');
        }
      } else {
        // Remove the installation product from the cart
        if (this.lineItemId) { // Only remove if a gift is actually tracked
          console.log('Checkbox unchecked, removing product with lineItemId:', this.lineItemId);
          await this.removeGiftProduct();
        }
      }
    } catch (error) {
      console.error("Error in handleCheckboxChange:", error);
      document.getElementById('notification-cart-errors').textContent = window.cartStrings.error || 'An error occurred.';
    } finally {
        if (this.checkbox) this.checkbox.disabled = false;
        if (cartDrawer) cartDrawer.classList.remove('cart__items--disabled');
    }
  }

  addProductWithProperties(id, quantity) {
    // Create a properties object with the main product title
    const properties = {
      'Cadeau voor': this.mainProductTitle,
      'Original line item id': this.mainProductId
    };

    console.log('Adding product with properties:', { id, quantity, properties });

    // Create the request body with the properties
    const body = JSON.stringify({
      id,
      quantity,
      properties,
      parent_line_key: this.lineItemKey,
      sections: this.cartItems.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    console.log('Request body:', body);

    // Send the request to add the product with properties
    return fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        console.log('Add product response status:', response.status);
        if (!response.ok) {
          return response.text().then(text => {
            console.error('Error response:', text);
            throw new Error(`HTTP error! ${response.status}`);
          });
        }
        return response.text();
      })
      .then((state) => {
        console.log('Add product success, parsing state');
        const parsedState = JSON.parse(state);
        this.cartItems.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');
        // const cartItems = document.getElementById('main-cart-items'); // cartItems is ProductGift's this.cartItems

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.cartItems.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      
          elementToReplace.innerHTML =
            this.cartItems.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
        
        const mainCartItems = document.getElementById('main-cart-items'); // get it directly
        if (mainCartItems) mainCartItems.scrollIntoView();
        return parsedState;
      })
      .catch((e) => {
        console.error('Error adding product:', e);
        // this.cartItems.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden')); // cartItems doesn't have qSA
        document.getElementById('notification-cart-errors').textContent = window.cartStrings.error;
        throw e;
      });
  }


  async removeGiftProduct() {
    // Get the line item index from the data-index attribute
    // const lineIndex = this.dataset.index; // This is the 1-based index of the gift product in the cart
    const giftProductLineKey = this.lineItemId; // This is the key of the gift product line item

    // console.log('Removing installation product with index:', lineIndex, 'and ID (key):', giftProductLineKey);
    console.log('Attempting to remove gift product with line key:', giftProductLineKey);
    
    // We need the line index for updateQuantity's internal UI updates.
    // However, data-index on gift-product might not always be set or might be for a different item.
    // The most reliable way to remove is by its key (this.lineItemId).
    // The updateQuantity method needs a 'line' for UI side effects, but these might not be relevant
    // if the gift product isn't displayed as a typical line item with Line-item-error-X etc.
    // For removal, the key is paramount. We might need to find the line index dynamically if needed for UI.
    // Or, ensure `data-index` on `gift-product` is indeed the correct 1-based index of the gift line item.
    // Liquid provides `gift_product_index` for `data-index` if `has_gift_product`.

    if (this.cartItems && giftProductLineKey) {
      // If `this.dataset.index` (gift_product_index) is available and correct for the gift line item, use it.
      // Otherwise, cart re-render will fix UI. The critical part is removing by key.
      const lineIndexForUIMaybe = this.dataset.index; 
      console.log('Using lineIndexForUIMaybe:', lineIndexForUIMaybe, 'and key:', giftProductLineKey, 'for removal.');
      try {
          // The 'name' and 'input' params for updateQuantity are less relevant for a direct removal by key.
          // 'updates[]' is a common name.
         return await this.cartItems.updateQuantity(lineIndexForUIMaybe, 0, 'updates[]', null, giftProductLineKey);
      } catch (error) {
          console.error("Failed to remove gift product:", error);
          // Error is already handled and re-thrown by updateQuantity
          throw error;
      }
    } else {
      console.log('Missing required data for removal (cartItems or giftProductLineKey):', { giftProductLineKey, cartItems: !!this.cartItems });
      return Promise.resolve(); // Or reject, if this state is an error
    }
  }

}

customElements.define('gift-product', ProductGift);